var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CRow',[_c('CCol',[_c('CCard',[_c('CCardBody',[_c('vue-google-heatmap',{attrs:{"points":_vm.points,"height":550,"lat":-7.600909,"lng":111.901173}})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }